type WorkflowTerminology = {
	singular: string
	plural: string
}

export const useTerminology = () => {
	const appName: string = globalThis.appSettings.APP_NAME
	const workflow: WorkflowTerminology = globalThis.appSettings.TERMINOLOGY.workflow
	
	return {
		appName,
		workflow
	}
}